import { useEffect, useMemo, useState } from 'react';
import PageShell from '../../../components/layout/PageShell';
import { useAuth } from '../../../context/AuthContext';
import { getStreamingDashboard } from '../../../services/matchService';
import { normalizeDashboardItem } from '../utils/streamingDashboardUtils';

const TournamentStreamingOperationsPage = () => {
  const { token } = useAuth();
  const [items, setItems] = useState([]);

  useEffect(() => {
    const load = async () => {
      const payload = await getStreamingDashboard({ token, limit: 250 });
      setItems((payload?.items || []).map(normalizeDashboardItem));
    };
    if (token) load();
  }, [token]);

  const groups = useMemo(() => {
    const map = new Map();
    items.forEach((row) => {
      const key = row.tournamentId || 'unknown';
      if (!map.has(key)) map.set(key, { name: row.tournamentName || 'Unknown tournament', rows: [] });
      map.get(key).rows.push(row);
    });
    return Array.from(map.entries());
  }, [items]);

  return (
    <PageShell>
      <h1 className="h4 mb-3">Tournament streaming operations</h1>
      {groups.map(([id, group]) => (
        <div className="card mb-3" key={id}>
          <div className="card-header py-2 d-flex justify-content-between">
            <strong>{group.name}</strong>
            <span className="small text-muted">{group.rows.length} streams</span>
          </div>
          <div className="card-body py-2">
            {group.rows.map((row) => (
              <div key={`${row.streamType}-${row.matchId}`} className="d-flex justify-content-between border-bottom py-1 small">
                <span>{row.matchName} ({row.streamType})</span>
                <span>{row.isLive ? 'LIVE' : 'OFFLINE'} • alerts {(row.alerts || []).length}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </PageShell>
  );
};

export default TournamentStreamingOperationsPage;
